import React from "react";
import styles from "./MiniCardToggle.module.scss";

const MiniCardToggle = ({
  title,
  image,
  icon,
  footerContent,
  isOpen,
  onToggle,
}) => {
  return (
    <div
      className={`${styles.cardContainer} ${isOpen ? styles.cardActive : ""}`}
      onClick={onToggle}
    >
      {icon ? (
        <div className={styles.cardIconWrapper}>
          <span className={styles.cardIcon}>{icon}</span>
        </div>
      ) : image ? (
        <div className={styles.cardImageWrapper}>
          <img src={image} alt={title} className={styles.cardImage} />
        </div>
      ) : null}

      <div className={styles.cardHeader}>
        <h3>{title}</h3>
      </div>

      {footerContent && (
        <div className={styles.cardFooter}>
          {footerContent}
        </div>
      )}
    </div>
  );
};

export default MiniCardToggle;
